import Alpine from 'alpinejs';
import MiniMasonry from 'minimasonry';

Alpine.data('testimonialGrid', () => ({
    init() {
        const baseWidth = 460;
        const containerWidth = this.$el.getBoundingClientRect().width;
        if(containerWidth < baseWidth*2) {
            return;
        }

        this.$el.classList.add('children:absolute');
        const masonry = new MiniMasonry({
            container: this.$el,
            gutter: 16,
            surroundingGutter: false,
            baseWidth: baseWidth,
        });

        // poor man's solution for text changes
        const inNeosBackend = window.name === 'neos-content-main';
        if(inNeosBackend) {
            setInterval(() => masonry.layout(), 500);
        }
    },
}));
